import { ArrowBack } from "@mui/icons-material";
import { Alert, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import RewardForm from "./RewardForm";
import ConfettiExplosion from "react-confetti-explosion";
import Timeline from "./Timeline";
import useCart from "../utils/useCart";
import { useEffect } from "react";

export default function Finish(){

    const { cart, setCart } = useCart()

    useEffect(() => {

        setCart({ dpcStep: 3 })

    }, [setCart])

    return (
        <Stack spacing={3} sx={{maxWidth: 700, margin: 'auto'}}>

            {cart.reward && 
                <Timeline />
            }

            <Stack alignItems="center">
                <ConfettiExplosion />
            </Stack>

            <Alert severity="success">
                Félicitations, votre inscription a bien été prise en compte.
            </Alert>

            <RewardForm />

            <Button component={Link} to="/" startIcon={<ArrowBack />}>
                Retour à l'accueil
            </Button>

        </Stack>
    );
}